import { render, staticRenderFns } from "./BotonFlotanteComp.vue?vue&type=template&id=7f2fcf10&"
import script from "./BotonFlotanteComp.vue?vue&type=script&lang=js&"
export * from "./BotonFlotanteComp.vue?vue&type=script&lang=js&"
import style0 from "./BotonFlotanteComp.vue?vue&type=style&index=0&id=7f2fcf10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports